import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppThunkDispatch } from 'state/store';
import useSnackbarNotifications from 'Hooks/useSnackbarNotifications/useSnackbarNotifications';
import { v4 } from 'uuid';
import { Alert } from '@reach/alert';
import { Snackbar } from '@getsynapse/design-system';
import { createPortal } from 'react-dom';
import {
  selectUpdateLDTeamMembersNotifications,
  clearUpdateLDTeamMembersNotifications,
} from 'state/LearningTeam/learningTeamSlice';

const TeamMembersManagementNotifications = () => {
  const dispatch = useAppThunkDispatch();
  const updateLDTeamMembersNotifications = useSelector(
    selectUpdateLDTeamMembersNotifications
  );
  const {
    showNotification,
    notifications,
    hideNotification,
    notificationsIds,
  } = useSnackbarNotifications();

  useEffect(() => {
    if (
      updateLDTeamMembersNotifications &&
      updateLDTeamMembersNotifications.length > 0
    ) {
      updateLDTeamMembersNotifications.forEach((notification) => {
        const notificationId = v4();
        showNotification({
          id: notificationId,
          ...notification,
          title: notification.notificationTitle,
          message: notification.notificationMessage,
          variant: notification.notificationVariant,
          onCloseCallback: () => {
            hideNotification(notificationId);
          },
        });
      });
    }
  }, [updateLDTeamMembersNotifications, showNotification, hideNotification]);

  useEffect(() => {
    // Clear notifications when all notifications are closed
    if (
      notificationsIds.length === 0 &&
      updateLDTeamMembersNotifications &&
      updateLDTeamMembersNotifications.length > 0
    ) {
      dispatch(clearUpdateLDTeamMembersNotifications());
    }
  }, [notificationsIds, dispatch, updateLDTeamMembersNotifications]);

  return createPortal(
    <div className='fixed left-6 bottom-12 z-high flex flex-col gap-y-2'>
      {notifications.map((notification) => (
        <Alert key={notification.id} type='assertive'>
          <Snackbar {...notification} />
        </Alert>
      ))}
    </div>,
    document.body
  );
};

export default TeamMembersManagementNotifications;
